/**
 * Canvas Studio API — thin wrapper over the shared axios instance
 * (auth header + /api base are already configured there).
 * Backend: /api/canvas (see backend/routes/canvasRoutes.js).
 */
import api from '../../../api/axios';

export const canvasApi = {
  list: () => api.get('/canvas').then((r) => r.data),
  folders: () => api.get('/canvas/folders').then((r) => r.data),
  get: (id) => api.get(`/canvas/${id}`).then((r) => r.data),
  create: (body) => api.post('/canvas', body).then((r) => r.data),
  update: (id, body) => api.put(`/canvas/${id}`, body).then((r) => r.data),
  remove: (id) => api.delete(`/canvas/${id}`).then((r) => r.data),
  // Version snapshots
  listVersions: (id) => api.get(`/canvas/${id}/versions`).then((r) => r.data),
  createVersion: (id, label) => api.post(`/canvas/${id}/versions`, { label }).then((r) => r.data),
  restoreVersion: (id, versionId) => api.post(`/canvas/${id}/versions/${versionId}/restore`).then((r) => r.data),
  // Sharing — owner / Admin. permission: 'view' (read-only) | 'edit'.
  // Colleagues come from the same "active users except me" list Notes uses.
  listColleagues: () => api.get('/personal-notes/colleagues').then((r) => (Array.isArray(r.data) ? r.data : [])),
  getShares: (id) => api.get(`/canvas/${id}/shares`).then((r) => r.data),
  share: (id, userIds, permission = 'view') => api.post(`/canvas/${id}/share`, { user_ids: userIds, permission }).then((r) => r.data),
  setSharePermission: (id, userId, permission) => api.put(`/canvas/${id}/share/${userId}`, { permission }).then((r) => r.data),
  unshare: (id, userId) => api.delete(`/canvas/${id}/share/${userId}`).then((r) => r.data),
  // Comments — threads pinned at scene coords, with replies
  listComments: (id) => api.get(`/canvas/${id}/comments`).then((r) => r.data),
  // When I last opened this board's comments ({ read_at }); PUT marks all read now.
  getCommentsRead: (id) => api.get(`/canvas/${id}/comments/read`).then((r) => r.data),
  markCommentsRead: (id) => api.put(`/canvas/${id}/comments/read`).then((r) => r.data),
  addComment: (id, { body, x, y }) => api.post(`/canvas/${id}/comments`, { body, x, y }).then((r) => r.data),
  replyComment: (id, parentId, body) => api.post(`/canvas/${id}/comments`, { body, parent_id: parentId }).then((r) => r.data),
  updateComment: (id, commentId, patch) => api.put(`/canvas/${id}/comments/${commentId}`, patch).then((r) => r.data),
  deleteComment: (id, commentId) => api.delete(`/canvas/${id}/comments/${commentId}`).then((r) => r.data),
};

export default canvasApi;
